import { CheckoutLoginResponse } from '@as-react/common-types';
import type { MutationKey, UseMutationOptions } from '@tanstack/react-query';
import { loginGuest, AuthLoginGuestParams, loginCheckout, AuthLoginCheckoutParams } from './auth.api';
import type { OptionalMutationOptions, QueryApiOptions } from '../../types/types';

export const authMutationsKeys = {
  all: () => ['auth'] as MutationKey,
  loginGuest: () => [...authMutationsKeys.all(), 'loginGuest'] as MutationKey,
  loginCheckout: () => [...authMutationsKeys.all(), 'loginCheckout'] as MutationKey,
};

export const authMutations = (apiOptions: QueryApiOptions) => ({
  loginGuestMutation: (
    options: OptionalMutationOptions<undefined, AuthLoginGuestParams> = {}
  ): UseMutationOptions<undefined, Error, AuthLoginGuestParams> => ({
    ...options,
    mutationKey: authMutationsKeys.loginGuest(),
    mutationFn: (params: AuthLoginGuestParams) => loginGuest(apiOptions, params),
  }),
  loginCheckoutMutation: (
    options: OptionalMutationOptions<CheckoutLoginResponse, AuthLoginCheckoutParams> = {}
  ): UseMutationOptions<CheckoutLoginResponse, Error, AuthLoginCheckoutParams> => ({
    ...options,
    mutationKey: authMutationsKeys.loginCheckout(),
    mutationFn: (params: AuthLoginCheckoutParams) => loginCheckout(apiOptions, params),
  }),
});
